import React from 'react';

import { Provider } from 'react-redux';
import { CreateFirstBmc } from './createFirstBmc';
import store from './store';
import {
  LocalizationProvider,
  useLocalization,
} from '../../common/localization';
import { OnboardingLayout } from '../onboarding/OnboardingLayout';

function AppShell() {
  const { locales } = useLocalization();
  return (
    <OnboardingLayout data={{}} locales={locales}>
      <CreateFirstBmc locales={locales} />
    </OnboardingLayout>
  );
}

export default function App({ locales }) {
  return (
    <Provider store={store}>
      <LocalizationProvider initialLocales={locales}>
        <AppShell />
      </LocalizationProvider>
    </Provider>
  );
}
